// Redux Related
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
// constants
import {
  PAYMENT_APPLICATION_FAILURE,
  PAYMENT_DENIED,
  PAYMENT_FAILED,
} from 'src/constants/paymentCodes';

// components
import { ErrorLayout } from 'src/components/screens/components';
import ErrorPaymentLayout from './PaymentErrorLayout';

const isPaymentError = (error: string): boolean =>
  [PAYMENT_FAILED, PAYMENT_DENIED, PAYMENT_APPLICATION_FAILURE].includes(error);

export const EmissionErrorHandler = ({
  errorDetail,
  errorDetailDescription,
}: Props): JSX.Element => {
  if (isPaymentError(errorDetail)) {
    return <ErrorPaymentLayout data-testid="payment-error" />;
  }
  if (errorDetailDescription.includes('is registered in a valid policy')) {
    const messasgeDescription =
      'verifica que no exista una póliza vigente para este vehículo';
    return (
      <ErrorPaymentLayout
        messasgeDescription={messasgeDescription}
        data-testid="payment-error"
      />
    );
  }
  return <ErrorLayout data-testid="general-error" />;
};

export const mapStateToProps = (
  state: RootState,
): {
  errorDetail: string;
  errorDetailDescription: string;
} => ({
  errorDetail: state.emissionPolicy.emissionErrorDetail,
  errorDetailDescription: state.emissionPolicy.emissionErrorDetailDescription,
});

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector>;

export default connector(EmissionErrorHandler);
